export default {
	messages: {
		de: {
			organizationData: 'Organisation',
			display: 'Anzeige',
			defaultValues: 'Standard-Werte',
		},
		en: {
			organizationData: 'Organization Data',
			display: 'Display',
			defaultValues: 'Default Values',
		},
	},
};
